import {
  SET_OVERLOADING
} from '../../../action/types';

//initialize dashboard state-
const INIT_STATE = {
  loading: false,
};
//---------------------------

/**********************
 * Auth user reducers *
 **********************/
export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case SET_OVERLOADING:
      return { loading: action.payload };

    default: return { ...state };
  }
}
